export const CUSTOMER_PORTAL_PAGE_SIZE = 10;
